const FeaturedTopicsAcronyms: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>
        &#10132;{" "}
        <a href="/featured-topics" className="breadcrumb-link">
          Featured Topics
        </a>
        &#10132; Acronyms used on CEO.CA
      </p>
      <h2 className="help-heading">Acronyms used on CEO.CA</h2>
      <p>
        <span style={{ fontWeight: "bold" }}>AGM</span> &emsp; Annual General
        Meeting
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>AISC</span> &emsp; All in
        sustaining cost (mining)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>ATH</span> &emsp; All time high
        (share price)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>ATL</span> &emsp; All time low
        (share price)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>BO</span> &emsp; Buy Out
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>BV</span> &emsp; Book Value -
        refers to the total amount a company would be worth if it liquidated its
        assets and paid back all its liabilities.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>CCAA</span> &emsp; Companies'
        Creditors Arrangement Act
      </p>
      <p style={{ fontStyle: "italic" }}>
        Allows insolvent corporations owing their creditors in excess of $5
        million to restructure their business and financial affairs.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>CF</span> &emsp; Credit Facility,
        Cash Flow
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>COGS</span> &emsp; Cost of Goods
        Sold
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>DA</span> &emsp; Definitive
        Agreement
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>DD</span> &emsp; Due Diligence
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>EBITA</span> &emsp; Earnings Before
        Interest, Taxes, Depreciation and Amortization
      </p>
      <p style={{ fontStyle: "italic" }}>
        EBITDA is essentially net income (or earnings) with interest, taxes,
        depreciation, and amortization added back. EBITDA can be used to analyze
        and compare profitability among companies and industries, as it
        eliminates the effects of financing and capital expenditures.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>EOD</span> &emsp; End of day
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>EOW</span> &emsp; End of week
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>EPS</span> &emsp; earnings per
        share - profit divided by outstanding shares of its common stock
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>ER</span> &emsp; Earnings Report
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>EV</span> &emsp; Enterprise Value
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>FA</span> &emsp; Financial Advisor
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>FCF</span> &emsp; Free Cash Flow
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Fins, FS</span> &emsp; Financial
        Statements
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Float</span> &emsp; Shares
        currently available on the market
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Free Float</span> &emsp; = Outstanding Shares - Restricted Shares - Closely Held
        Shares
      </p>
      <p>Where:</p>
      <ul>
        <li>Outstanding shares refer to the total number of shares issues</li>
        <li>
          Restricted shares refer to shares that are not transferable until
          certain conditions are met. Restricted shares are generally held by
          corporate management, such as executives and directors.
        </li>
        <li>
          Closely held shares refer to shares that are typically held onto a
          very long-term basis. Examples include major long-term shareholders
          and insiders.
        </li>
      </ul>
      <p>
        <span style={{ fontWeight: "bold" }}>FOMO</span> &emsp; Fear of Missing
        Out
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>FUD</span> &emsp; Fear, Uncertainty
        and Doubt - questioning and negative statements spread by those who want
        to influence sentiment{" "}
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Fully Diluted</span>
      </p>
      <p style={{ fontStyle: "italic" }}>
        Fully diluted shares are the total number of common shares of a company
        that will be outstanding and available to trade on the open market after
        all possible sources of conversion, such as warrants, convertible bonds
        and employee stock options, are exercised.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>G&A</span> &emsp; General and
        Administartive Expenses
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>IIROC</span> &emsp; Investment
        Industry Regulatory Organization of Canada. IIROC oversees all
        investment dealers and trading activity on debt and equity markets in
        Canada. <a href="https://iiroc.ca">www.iiroc.ca</a>
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>IR</span> &emsp; Investor Relations
        - staff at a company who answer investor questions about the company and
        the sector
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>JV</span> &emsp; Joint Venture
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>KPI</span> &emsp; Key performance
        indicators
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>L2</span> &emsp; Level 2: A listing
        or graphical presentation of the number of shares buyers are willing to
        buy (Bids) and sellers are willing to sell (Asks) at various price
        levels, also called a Depth Chart. Strong bids near the current price
        are considered bullish support for the stock as many are willing to buy.
        Weak bids indicate a lack of interest or bearish sentiment. Large asks
        could indicate a bearish sentiment, or simply traders taking advantage
        of stock trading in a narrow channel. A small number of asks or offers
        to sell indicates a bullish sentiment as fewer want to sell at that
        price.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>LC, LOC</span> &emsp; Letter of
        Credit is a payment mechanism used in international trade to provide an
        economic guarantee from a creditworthy bank to an exporter of goods.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>LOC</span> &emsp; Line of Credit
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>LC, L/C</span> &emsp; Letter of
        Credit
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>LOI</span> &emsp; Letter of Intent
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>LoU</span> &emsp; Letter of
        Undertaking, see LC
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>MC, MCap</span> &emsp; Market
        Capitalization (# of shares x price per share)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>MM</span> &emsp; Market Maker
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>MOMO</span> &emsp; Momentum
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>MOU</span> &emsp; Memorandum of
        Understanding
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>NR</span> &emsp; News Release
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>OpEx</span> &emsp; Operating
        Expenses
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>P&D</span> &emsp; Pump and Dump
        (Run the share price up and then sell large amounts of shares into the
        large volume of buying)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>PP</span> &emsp; Private Placement
        - a sale of stocks, bonds, or securities directly to a private investor,
        rather than as part of a public offering.
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>pps</span> &emsp; Price per share
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>PR</span> &emsp; Public Relations,
        Press Release
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>PT</span> &emsp; Price Target
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Revs</span> &emsp; Revenues
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>RS, RB</span> &emsp; Reverse split
        / rollback - also known as consolidation of shares is when a company
        reduces the number of shares. For example, a 5:1 rollback will result in
        a shareholder receiving 1 share for every 5 they previously held. As a
        result, the share price will be multiplied by 5, and depending on the
        strength of the company, may go up from there, or drift back down.
        Typical reasons for an RS are to have the ability to raise more capital
        at a higher share price, up list to another exchange or tighten the
        share structure to attract new investors
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>RTO</span> &emsp; Reverse Take Over
        - when a private company buys a public company in order to shortcut the
        process of listing on an exchange
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>SEDAR</span> &emsp; System for
        Electronic Document Analysis and Retrieval
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>SEDI</span> &emsp; System for
        Electronic Disclosure by Insiders
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>SG&A</span> &emsp; Selling, general
        and administrative expense
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>Shares OS</span> &emsp; Shares
        Outstanding - total number of shares issued (includes trading and
        non-trading shares - see Float)
      </p>
      <p>
        <span style={{ fontWeight: "bold" }}>VWAP</span> &emsp; Volume weighted
        average price
      </p>
    </div>
  );
};

export default FeaturedTopicsAcronyms;
